import * as React from 'react';
import cn from 'clsx';

import { CardHeader } from '../CardHeader';
import { ContentList } from '../../../ContentList';
import { EHeaderIcons, ICard } from '../../../types/types';

import * as styles from './styles.css';

interface ICardProps extends ICard {
  className?: string;
  titleIcon: EHeaderIcons;
}

export const Card: React.FC<ICardProps> = props => {
  return (
    <div className={cn(styles['wrapper'], props.className)}>
      <CardHeader title={props.title} icon={props.titleIcon} />
      <ContentList className={styles['content']} content={props.content} />
    </div>
  );
};

Card.displayName = 'Card';
